var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sumCount > 0)?_c('span',{staticClass:"label bg-orange"},[_vm._v(_vm._s(_vm.sumCount))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }